export default __webpack_public_path__ + "static/media/stack_coin.7f0d87ba.png";